import { getCurrentInstance, computed, ref, watch } from '@vue/composition-api'
import mobile from 'is-mobile'
export default function useDashboardRender () {
    const mobileSize = ['xs', 'sm', 'md']
    const vm = getCurrentInstance().proxy
    const store = vm.$store
    const userDashboardKey = `C${store.getters.authUserInfo['userIdx']}`
    const layout = computed(() => store.getters['$_dashboard/customDashboard'])
    const layoutMap = computed(() => layout.value.reduce((acc, cur) => {
        acc[cur.i] = cur
        return acc
    }, {}))

    const breakPoint = computed(() => store.getters['app/currentBreakPoint'])
    const viewType = ref(mobile() || mobileSize.includes(breakPoint.value) ? 'mobile' : 'web')

    watch(breakPoint, (value, oldValue) => {
        viewType.value = (mobile() || mobileSize.includes(value)) ? 'mobile' : 'web'
    })

    const editDashboard = computed(() => store.getters['$_dashboard/editDashboard'])
    const updateEditDashboard = (value) => store.commit('$_dashboard/UPDATE_EDIT_DASHBOARD', value)
    const windowWidth = computed(() => store.state['app']['windowWidth'])
    const dashboardEditMode = computed(() => store.getters['appConfig/dashboardEditMode'])

    const responsiveCard = {
        'card-statistics': { increaseH: 2, isIncreased: false },
        'card-total-cost': { increaseH: 9, isIncreased: false }
    }
    const changeLayout = (breakPoint, sortedCards, currentMap) => {
        let y = 0
        return sortedCards.reduce((acc, cur, i) => {
            let cardHeight = currentMap[cur].h + (breakPoint === 'xs' && responsiveCard[cur]?.isIncreased ? responsiveCard[cur].increaseH : 0)
            if (breakPoint === 'xs' && responsiveCard[cur]?.increaseH > 0) {
                cardHeight += responsiveCard[cur].increaseH
                responsiveCard[cur].isIncreased = true
            }
            acc.push({
                x: 0,
                y: y,
                w: 24,
                h: cardHeight,
                i: cur
            })
            y += cardHeight
            return acc
        }, [])
    }
    const getNextPosition = (cardsData, newCardWidth, newCardHeight) => {
        const maxWidth = 24
        let layout = []

        for (const card of cardsData) {
            for (let y = card.y; y < card.y + card.h; y++) {
                if (!layout[y]) layout[y] = []
                for (let x = card.x; x < card.x + card.w; x++) {
                    layout[y][x] = true
                }
            }
        }

        for (let y = 0; ; y++) {
            for (let x = 0; x <= maxWidth - newCardWidth; x++) {
                let canPlace = true
                for (let dy = 0; dy < newCardHeight; dy++) {
                    if (!layout[y + dy]) layout[y + dy] = []
                    for (let dx = 0; dx < newCardWidth; dx++) {
                        if (layout[y + dy][x + dx]) {
                            canPlace = false
                            break
                        }
                    }
                    if (!canPlace) break
                }
                if (canPlace) return { x, y }
            }
        }
    }
    function layoutReducer (acc, cur) {
        acc[cur.i] = cur
        return acc
    }
    function sortCardsByPosition (cardsData) {
        const sortedCards = cardsData.slice().sort((card1, card2) => {
            if (card1.y !== card2.y) {
                return card1.y - card2.y
            } else {
                return card1.x - card2.x
            }
        })
        return sortedCards.map(card => card.i)
    }
    const getCurrentLayoutMobile = (sortedCards, currentMap = layoutMap.value) => {
        return {
            smLayout: changeLayout('sm', sortedCards, currentMap),
            xsLayout: changeLayout('xs', sortedCards, currentMap)
        }
    }

    return {
        windowWidth,
        userDashboardKey,
        viewType,
        breakPoint,
        layoutMap,
        layout,
        dashboardEditMode,
        getNextPosition,
        layoutReducer,
        sortCardsByPosition,
        getCurrentLayoutMobile,
        editDashboard,
        updateEditDashboard
    }
}
